module.exports = __webpack_public_path__ + "img/zfb_4.484c5906.png";